




























import { Vue, Component } from "vue-property-decorator";
import MaxWidthSection from "./MaxWidthSection.vue";
import GrButton from "./GrButton.vue";
import GrBottomBackground from "./GrBottomBackground.vue";
import ApplyForAccountEmail from "./ApplyForAccountEmail.vue";
import { publicDataStore } from "~/store";

@Component({
  components: {
    MaxWidthSection,
    GrBottomBackground,
    GrButton,
    ApplyForAccountEmail,
  },
})
export default class BottomInterestForm extends Vue {
  get appliedEmail() {
    return publicDataStore.appliedData?.email ?? null;
  }
}
